import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Floor
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene

        this.setGeometry()
        this.setMaterial()
        this.setMesh()
    }

    setGeometry()
    {
        this.geometry = new THREE.PlaneGeometry(9, 7)
    }

    setMaterial()
    {
        this.material = new THREE.MeshStandardMaterial({
            color: '#d8d3c7',
            roughness: 0.82,
            metalness: 0
        })
    }

    setMesh()
    {
        this.mesh = new THREE.Mesh(this.geometry, this.material)
        this.mesh.rotation.x = - Math.PI * 0.5
        this.mesh.position.y = -0.01
        this.mesh.receiveShadow = true
        this.scene.add(this.mesh)

        this.grid = new THREE.GridHelper(9, 18, '#c0baad', '#e2ded5')
        this.grid.position.y = 0
        this.grid.material.opacity = 0.35
        this.grid.material.transparent = true
        this.scene.add(this.grid)
    }
}
